import React from "react";

export default function BreadcrumbSection() {
	return (
		<div className="fugu--breadcrumbs-section">
			<div className="fugu--breadcrumbs-data center-content">
				<h1 className="wow fadeInUpX" data-wow-delay="0s">
					Get in touch with us
				</h1>
				<p className="wow fadeInUpX" data-wow-delay="0.15s">
					We are here to help. Just send us a message to get any of your questions answered and we will get
					back to you within 24-48 hours or as soon as possible.
				</p>
			</div>
		</div>
	);
}
